function PresidentesTimeline({ presidentes = [] }) {
    if (!presidentes.length) {
        return null;
    }

    return (
        <section className="mx-auto max-w-5xl">
            <div className="relative flex flex-col before:absolute before:top-0 before:bottom-0 before:left-2.5 before:w-[2px] before:bg-green-500/20 md:before:left-1/2 md:before:-translate-x-1/2">
                {presidentes.map((presidente, index) => {
                    const periodo = presidente.periodo?.trim() || "";
                    const isCurrent = periodo.endsWith("-") || /presente/i.test(periodo);
                    const isLeft = index % 2 === 0;
                    const usesGreenPanel = isCurrent || index % 2 !== 0;
                    const presidentNumber = presidente.numero ?? presidentes.length - index;
                    const panelClass = usesGreenPanel
                        ? "border-green-500/20 bg-[#102216] ring-1 ring-green-500/20 shadow-lg shadow-green-500/5 hover:bg-[#15301d]"
                        : "border-red-500/20 bg-[#221010] ring-1 ring-red-500/20 shadow-lg shadow-red-500/5 hover:bg-[#2a1414]";

                    return (
                        <article
                            key={`${presidente.nombre}-${presidente.comentario || ""}-${presidente.periodo}-${index}`}
                            className="relative grid grid-cols-1 pb-6 md:grid-cols-2 md:pb-10"
                        >
                            <div className={`pl-9 md:pl-0 ${isLeft ? "md:col-start-1 md:pr-16 md:text-right" : "md:col-start-2 md:pl-16"}`}>
                                <div className={`rounded-xl border p-3.5 md:p-5 transition-all ${panelClass}`}>
                                    <h3 className={`text-base md:text-2xl font-bold uppercase tracking-wide mb-1 flex items-start ${isCurrent ? "text-green-400" : "text-white"} ${isLeft ? "md:justify-end" : "md:justify-start"}`}>
                                        {isLeft ? null : <span className={`size-1.5 md:size-2 rounded-full mt-1.5 md:mt-2 ${isCurrent ? "bg-green-400" : "bg-slate-400"}`} />}
                                        <span className="flex flex-col">
                                            <span className={`flex items-center gap-1.5 md:gap-2 justify-start ${isLeft ? "md:justify-end md:flex-row-reverse" : "md:justify-start"}`}>
                                                <span className="inline-flex h-5 min-w-5 md:h-7 md:min-w-7 items-center justify-center rounded-full border border-green-500/30 bg-[#102216] px-1.5 md:px-2 text-[10px] md:text-xs font-bold leading-none text-red-400">
                                                    #{presidentNumber}
                                                </span>
                                                <span>{presidente.nombre}</span>
                                            </span>
                                            {presidente.comentario ? (
                                                <span className={`text-[10px] md:text-sm font-medium normal-case tracking-normal leading-tight ${isCurrent ? "text-green-500" : "text-slate-400"}`}>
                                                    {presidente.comentario}
                                                </span>
                                            ) : null}
                                        </span>
                                        {isLeft ? <span className={`size-1.5 md:size-2 rounded-full mt-1.5 md:mt-2 ${isCurrent ? "bg-green-400" : "bg-slate-400"}`} /> : null}
                                    </h3>
                                    <p className={`font-medium text-xs md:text-lg whitespace-pre-line ${isCurrent ? "text-green-500" : "text-slate-300"}`}>
                                        {presidente.periodo}
                                    </p>
                                </div>
                            </div>

                            <div className={`absolute left-0 top-1 z-10 h-5 w-5 md:top-1.5 md:h-6 md:w-6 rounded-full border-4 border-[#062a1a] md:left-1/2 md:-translate-x-1/2 ${isCurrent ? "bg-green-500" : "bg-green-500/70"}`} />
                        </article>
                    );
                })}
            </div>
        </section>
    );
}

export default PresidentesTimeline;